<template>
  <div class="change-c">
    <!-- 厂商 -->
    <div
        class="select-li clear"
        :class="changetype==3?'select-libot':''"
        v-show="nowNav==2&&changetype==0||nowNav==2&&changetype==3"
    >
      <label class="tag-title">选择厂商：</label>
      <el-checkbox @change="allBtn3" class="check-all" v-model="cproductall3">全部</el-checkbox>
      <div class="right">
        <button @click="clickBtn0" class="btn">{{ btntext0 }}</button>
      </div>
      <div style="padding-left: 85px">
        <el-checkbox-group
            :class="btntext0==='展开'?'check-option-min':'check-option-max'"
            v-model="checkVendor"
            :max="50"
            @change="handleCheckedCitiesChange0"
        >
          <el-checkbox
              class="ml"
              v-for="car in vendorList"
              :title="car.title"
              :label="car.name"
              :key="car.name"
          >
            <!-- <div v-if="car.tag=='本品'" class="line-erect"></div> -->
            <div class="name-style">{{ car.name2 }}</div>
            <img v-if="car.tag=='本品'" class="img-v" src="../../assets/img/new/icon-j.png" alt/>
            <!-- <img v-if="car.tag=='竞品'" class="img-v" src="../../assets/img/new/icon-j2.png" alt /> -->
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </div>

    <!-- 品牌 -->
    <div
        class="select-li clear"
        :class="changetype==3?'select-libot':''"
        v-show="nowNav==1&&changetype==0||nowNav==1&&changetype==3"
    >
      <label class="tag-title">品 牌：</label>
      <el-checkbox @change="allBtn2" class="check-all" v-model="cproductall2">全部</el-checkbox>
      <div class="right">
        <button @click="clickBtn" class="btn">{{ btntext }}</button>
      </div>
      <div style="padding-left: 85px">
        <el-checkbox-group
            :class="btntext==='展开'?'check-option-min':'check-option-max'"
            v-model="checkedCar"
            :max="50"
            @change="handleCheckedCitiesChange"
        >
          <el-checkbox
              class="ml"
              v-for="car in carBanner"
              :title="car.title"
              :label="car.id"
              :key="car.id"
          >
            <!-- <div v-if="car.tag=='本品'" class="line-erect"></div> -->
            <div class="name-style">{{ car.name }}</div>
            <img v-if="car.tag=='本品'" class="img-v" src="../../assets/img/new/icon-j.png" alt/>
            <!-- <img v-if="car.tag=='竞品'" class="img-v" src="../../assets/img/new/icon-j2.png" alt /> -->
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </div>

    <!-- 产品 -->
    <div
        v-show="nowNav==0&&changetype==0||nowNav==0&&changetype==3"
        class="select-li clear"
        :class="changetype==3?'select-libot':''"
    >
      <label class="tag-title">产品：</label>
      <div class="right">
        <button @click="clickBtn2" class="btn">{{ btntext2 }}</button>
      </div>
      <div style="padding-left: 85px">
        <el-checkbox-group
            :class="btntext2==='展开'?'check-option-min':'check-option-max'"
            v-model="checkedProduct"
            :max="50"
            @change="handleCheckedCitiesChange2"
        >
          <el-checkbox
              v-for="car in carProduct"
              :title="car.title"
              :label="car.id"
              :key="car.id"
          >
            <!-- <div v-if="car.tag=='本品'" class="line-erect"></div> -->
            <div class="name-style">{{ car.name2 }}</div>
            <img v-if="car.tag=='本品'" class="img-v" src="../../assets/img/new/icon-j.png" alt/>
            <!-- <img v-if="car.tag=='竞品'" class="img-v" src="../../assets/img/new/icon-j2.png" alt /> -->
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </div>

    <!-- 内容分类 -->
    <div class="select-li clear" v-if="content&&changetype==0">
      <label class="tag-title">内容分类：</label>
      <div class="fz">
        <el-radio class="radio" v-model="radio" :label="true">全部</el-radio>
        <el-radio class="radio" v-model="radio" :label="false">提及分类</el-radio>
        <el-select
            v-model="grade1"
            size="mini"
            class="selectW"
            :disabled="radio"
            clearable
            placeholder="一级分类"
            @change="onechange"
        >
          <el-option
              v-for="item in oneList"
              :key="item.cname"
              :label="item.cname"
              :value="item.cname"
          ></el-option>
        </el-select>
        <el-select
            v-model="grade2"
            class="selectW"
            :disabled="radio"
            size="mini"
            clearable
            placeholder="二级分类"
            @change="twochange"
        >
          <el-option
              v-for="item in twoList"
              :key="item.cname"
              :label="item.cname"
              :value="item.cname"
          ></el-option>
        </el-select>
        <el-select
            v-model="grade3"
            size="mini"
            class="selectW"
            :disabled="radio"
            clearable
            @change="threechange"
            placeholder="三级分类"
        >
          <el-option
              v-for="item in threeList"
              :key="item.cname"
              :label="item.cname"
              :value="item.cname"
          ></el-option>
        </el-select>
      </div>
    </div>
    <!-- 媒体 -->
    <div class="select-li clear" v-show="btntext3=='展开'&&changetype==0">
      <label class="tag-title">媒体：</label>
      <el-checkbox @change="allBtnpm" class="check-all" v-model="cproductallm">全部</el-checkbox>
      <div class="right">
        <button @click="clickBtn3" class="btn">{{ btntext3 }}</button>
      </div>
      <div class="fz">
        <el-checkbox-group
            class="check-option"
            v-model="checkMedia"
            @change="handleCheckedCitiesChange3"
        >
          <el-checkbox
              class="ml"
              v-for="car in mediaData"
              :label="car.id"
              :key="car.id"
          >{{ car.media_name }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <div class="select-li clear" style="padding-top:8px" v-if="btntext3=='收起'&&changetype==0">
      <label class="tag-title mt">媒体：</label>
      <el-checkbox @change="allBtnpm" class="check-all mt" v-model="cproductallm">全部</el-checkbox>
      <div class="right mt">
        <button @click="clickBtn3" class="btn">{{ btntext3 }}</button>
      </div>
      <div class="fz open-new">
        <el-checkbox-group
            class="check-option"
            :class="{'open':btntext3==='收起'}"
            v-model="checkMedia"
            @change="handleCheckedCitiesChange3"
        >
          <el-checkbox
              class="ml"
              v-for="car in mediaData"
              :label="car.id"
              :key="car.id"
          >{{ car.media_name }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </div>

    <!-- 整体情感 -->
    <div class="select-li clear" v-if="emotion&&changetype==0">
      <label class="tag-title">整体情感：</label>

      <div class="fz" style=" width: 1000px;">
        <el-radio-group v-model="emotionRadio" @change="emotionChange">
          <el-radio class="radio" :label="0">全部</el-radio>
          <el-radio class="radio" :label="2">一般负面</el-radio>
          <el-radio class="radio" :label="3">重大负面</el-radio>
          <el-radio class="radio" :label="1">非负</el-radio>
        </el-radio-group>
      </div>
    </div>
    <!-- 时间范围 -->
    <div class="select-li clear" v-if="changetype==0||changetype==1">
      <label class="tag-title">时间范围：</label>

      <div class="fz" style=" width: 1005px;">
        <el-radio-group v-model="timeRadio" @change="radioChange">
          <el-radio class="radio" :label="1">本年</el-radio>
          <el-radio class="radio" :label="2">本季</el-radio>
          <el-radio class="radio" :label="3">本月</el-radio>
          <el-radio class="radio" :label="4">今天</el-radio>
          <el-radio class="radio" :label="5">昨天</el-radio>
          <el-radio class="radio" :label="6">30天</el-radio>
          <el-radio class="radio" :label="7">90天</el-radio>
          <el-radio class="radio" :label="8">180天</el-radio>
          <el-radio class="radio" :label="0">自定义</el-radio>
        </el-radio-group>
        <el-date-picker
            style="width:234px;height:36px;margin-left:20px;padding:0 10px;"
            value-format="yyyy-MM-dd"
            :disabled="disabled"
            v-model="date"
            type="daterange"
            @change="changetime"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :picker-options="pickerOptions"
        ></el-date-picker>
      </div>
    </div>
    <!-- 网民或者媒体 -->
    <div class="select-li select-libot clear" v-if="emotion&&changetype==0">
      <label class="tag-title">类型：</label>

      <div class="fz" style=" width: 1000px;">
        <el-radio-group v-model="sourceRadio" @change="sourceChange">
          <el-radio class="radio" :label="0">全部</el-radio>
          <el-radio class="radio" :label="1">网民</el-radio>
          <el-radio class="radio" :label="2">媒体</el-radio>
        </el-radio-group>
      </div>
    </div>
  </div>
</template>
<script>
// import { resolve } from "dns";
import {rejects} from "assert";

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    iscarType: {
      type: Boolean,
      default: false
    },
    nowNav: {
      type: Number,
      default: 0
    },
    mediaType: {
      type: Number,
      default: 0
    },
    content: {
      type: Boolean,
      default: true
    },
    emotion: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selected: "",
      checkedCar: [],
      isBanner: true,
      carBanner: [],
      result: [],
      btntext: "展开",
      btntext2: "展开",
      btntext3: "展开",
      btntext4: "展开",
      btntext5: "展开",
      btntext0: "展开",
      checkedCarType: [],
      carProduct: [],
      checkedProduct: [],
      checkEnergy: [],
      energyData: [], //能源
      isBanner2: true,
      radio: true,
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        }
      ],
      grade1: "", //一级
      grade2: "", //二级
      grade3: "", //三级
      mediaData: [], //媒体数据
      checkMedia: [], //选择媒体
      isBanner3: true, //媒体
      timeRadio: 0, //时间段选择
      date: "",
      disabled: false,
      allchange: {},
      oneList: [],
      twoList: [],
      threeList: [],
      floor: 1,
      floorName: "",
      isBanner4: true, //能源,
      carType: [],
      checkedCarType: [],
      isBanner5: true,
      isBanner0: true,

      nowindex: 0,
      Productfirst: true,
      productName: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "今日",
            onClick(picker) {
              const end = new Date();
              const start = new Date();

              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "昨日",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近7天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近30天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近90天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      // 车场
      vendorList: [],
      checkVendor: [],
      carProductAll: [],
      checkedProduct2: [],
      emotionRadio: 0,
      sourceRadio: 0,
      detetypeRadio: 1,
      changetype: 1,
      lastmeidio: "",
      checkedProduct1: "",
      start_timenew: "",
      end_timenew: "",
      cproductall: true,
      cproductall2: true,
      cproductall3: true,
      cproductallm: true
    };
  },
  async created() {
    this.init();
  },
  methods: {
    //厂商
    handleCheckedCitiesChange0(value) {
      let checkedCount = value.length;
      this.cproductall3 = checkedCount === this.vendorList.length;
      this.changeData();
    },

    // 品牌
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.cproductall2 = checkedCount === this.carBanner.length;

      this.changeData();
    },
    allBtn3(val) {
      let arry = [];
      this.vendorList.forEach(item => {
        arry.push(item.name);
      });

      this.checkVendor = val ? arry : [];
      this.changeData();
    },
    allBtn2(val) {
      let arry = [];
      this.carBanner.forEach(item => {
        arry.push(item.id);
      });

      this.checkedCar = val ? arry : [];
      this.changeData();
    },
    // 产品
    handleCheckedCitiesChange2(value) {
      if (value.length > 1) {
        let a = value[1];
        this.checkedProduct = [a];

        this.checkedProduct1 = a;
        this.changeData();
      } else {
        this.checkedProduct = [this.checkedProduct1];
      }
    },
    // 媒体
    handleCheckedCitiesChange3(value) {
      let checkedCount = value.length;
      this.cproductallm = checkedCount === this.mediaData.length;
      this.changeData();
    },
    allBtnpm(val) {
      let arry = [];
      this.mediaData.forEach(item => {
        arry.push(item.id);
      });

      this.checkMedia = val ? arry : [];
      this.changeData();
    },
    // 能源
    handleCheckedCitiesChange4(value) {
      let checkedCount = value.length;
      if (value.includes(0) && !this.isBanner4) {
        this.isBanner4 = true;
        let arry = [];
        this.energyData.forEach(item => {
          arry.push(item.id);
        });
        this.checkEnergy = arry;
      } else if (
          value.includes(0) &&
          this.isBanner4 &&
          checkedCount != this.energyData.length
      ) {
        this.isBanner4 = false;
        this.checkEnergy = [...value];
        this.checkEnergy.splice(0, 1);
      } else if (
          !value.includes(0) &&
          this.isBanner4 &&
          checkedCount === this.energyData.length - 1
      ) {
        this.isBanner4 = false;
        this.checkEnergy = [];
      } else if (
          !value.includes(0) &&
          !this.isBanner4 &&
          checkedCount === this.energyData.length - 1
      ) {
        this.isBanner4 = true;
        let arry = [];
        this.energyData.forEach(item => {
          arry.push(item.id);
        });
        this.checkEnergy = arry;
      }
      // this.changeData();
    },
    // 车型
    handleCheckedCitiesChange5(value) {
      let checkedCount = value.length;
      if (value.includes("全部") && !this.isBanner5) {
        this.isBanner5 = true;
        let arry = [];
        this.carType.forEach(item => {
          arry.push(item.cname);
        });
        this.checkedCarType = arry;
      } else if (
          value.includes("全部") &&
          this.isBanner5 &&
          checkedCount != this.carType.length
      ) {
        this.isBanner5 = false;
        this.checkedCarType = [...value];
        this.checkedCarType.splice(0, 1);
      } else if (
          !value.includes("全部") &&
          this.isBanner5 &&
          checkedCount === this.carType.length - 1
      ) {
        this.isBanner5 = false;
        this.checkedCarType = [];
      } else if (
          !value.includes("全部") &&
          !this.isBanner5 &&
          checkedCount === this.carType.length - 1
      ) {
        this.isBanner5 = true;
        let arry = [];
        this.carType.forEach(item => {
          arry.push(item.cname);
        });
        this.checkedCarType = arry;
      }

      this.changeData();
    },
    // 获取品牌
    async getCarData() {
      let company_type = window.localStorage.getItem("company_type");
      let res = await this.$api.communal.myBrandList();
      if (res.data.error === 0) {
        this.carBanner = [...res.data.data_no_rank];

        let arry = [];
        this.carBanner.forEach(item => {
          arry.push(item.id);
        });

        this.checkedCar = [...arry];
      }
      // if (company_type == 1) {

      // } else if (company_type == 2) {
      // let res = await this.$api.communal.brandList();
      // if (res.data.error === 0) {
      //   this.carBanner = [...res.data.data[0].list];
      //   // let obj = {
      //   //   id: 0,
      //   //   name: "全部"
      //   // };
      //   // this.carBanner.unshift(obj);
      //   let arry = [];
      //   this.carBanner.forEach((item, index) => {
      //     if (index < 50) {
      //       arry.push(item.id);
      //     }
      //   });

      //   this.checkedCar = [...arry];
      // }
      // }
    },
    // 点击展开
    clickBtn() {
      if (this.btntext === "展开") {
        this.btntext = "收起";
      } else {
        this.btntext = "展开";
      }
    },
    // 点击展开
    clickBtn2() {
      if (this.btntext2 === "展开") {
        this.btntext2 = "收起";
        // this.carProduct=this.carProductAll ;
        // let obj = {
        //   id: 0,
        //   name: "全部"
        // };
        // this.carProductAll.unshift(obj);
        // let arry = [];
        // this.carProductAll.forEach(item => {
        //   arry.push(item.id);
        // });
        // this.checkedProduct = [...arry];
      } else {
        this.btntext2 = "展开";
      }
    },
    // 点击展开
    clickBtn3() {
      if (this.btntext3 === "展开") {
        this.btntext3 = "收起";
      } else {
        this.btntext3 = "展开";
      }
    },
    // 点击展开
    clickBtn4() {
      if (this.btntext4 === "展开") {
        this.btntext4 = "收起";
      } else {
        this.btntext4 = "展开";
      }
    },
    // 点击展开
    clickBtn5() {
      if (this.btntext5 === "展开") {
        this.btntext5 = "收起";
      } else {
        this.btntext5 = "展开";
      }
    },
    // 点击展开
    clickBtn0() {
      if (this.btntext0 === "展开") {
        this.btntext0 = "收起";
      } else {
        this.btntext0 = "展开";
      }
    },
    // 获取产品
    async getProduct() {
      let company_type = window.localStorage.getItem("company_type");
      let res = await this.$api.communal.myProList();
      if (res.data.error === 0) {
        this.carProduct = [...res.data.data_no_rank];

        let arry = [];
        this.carProduct.forEach(item => {
          arry.push(item.id);
          if (item.name.length > 4) {
            item.name2 = item.name;
          } else {
            item.name2 = item.name;
          }
        });

        if (this.Productfirst) {
          if (this.carProduct.length <= 2 && this.carProduct.length > 1) {
            this.productName = [this.carProduct[1].name];
          } else if (
              this.carProduct.length <= 3 &&
              this.carProduct.length > 2
          ) {
            this.productName = [
              this.carProduct[0].name,
              this.carProduct[1].name
            ];
          } else if (this.carProduct.length > 3) {
            this.productName = [
              this.carProduct[0].name,
              this.carProduct[1].name,
              this.carProduct[2].name
            ];
          }
          this.Productfirst = false;
        }

        this.checkedProduct = [this.carProduct[0].id];
        this.checkedProduct1 = this.carProduct[0].id;
      } else {
      }
      // if (company_type == 1) {

      // } else if (company_type == 2) {
      //   let res = await this.$api.communal.proAllList();
      //   if (res.data.error === 0) {
      //     this.carProduct = [...res.data.data[0].list].splice(0, 300);
      //     this.carProductAll = [...res.data.data[0].list];

      //     this.carProductAll.forEach((t, index) => {
      //       if (index < 299) {
      //         this.checkedProduct2.push(t.id);
      //       }
      //     });

      //     let obj2 = {
      //       id: 10000,
      //       name: "其他冷门"
      //     };

      //     this.carProduct.push(obj2);
      //     let arry = [];
      //     this.carProduct.forEach((item, index) => {
      //       if (index < 50) {
      //         arry.push(item.id);
      //       }
      //     });

      //     if (this.Productfirst) {
      //       if (this.carProduct.length <= 2 && this.carProduct.length > 1) {
      //         this.productName = [this.carProduct[1].name];
      //       } else if (
      //         this.carProduct.length <= 3 &&
      //         this.carProduct.length > 2
      //       ) {
      //         this.productName = [
      //           this.carProduct[0].name,
      //           this.carProduct[1].name
      //         ];
      //       } else if (this.carProduct.length > 3) {
      //         this.productName = [
      //           this.carProduct[0].name,
      //           this.carProduct[1].name,
      //           this.carProduct[2].name
      //         ];
      //       }
      //       this.Productfirst = false;
      //     }

      //     this.checkedProduct = [this.carProduct[0].id];
      //     this.checkedProduct1 = this.carProduct[0].id;
      //   } else {
      //   }
      // }
    },
    // 获取媒体
    async getMedia() {
      let params = {
        media_type: 0
      };
      if (this.mediaType == 1) {
        params.media_type = 1;
      }
      let res = await this.$api.communal.mediaList(params);

      if (res.data.error == 0) {
        this.mediaData = [...res.data.data[0].list];
        this.mediaData.splice(0, 1);
        this.mediaData.forEach(item => {
          this.checkMedia.push(item.id);
        });
        this.lastmeidio = res.data.data[0].list.pop().media_name;
      }
    },
    async radioChange() {
      //  window.localStorage.setItem("timeRadio", this.timeRadio);
      let res = await this.$api.communal.GetALLdate();
      if (res.data.error === 0) {
        console.log("res", res);
        if (this.timeRadio === 0) {
          this.disabled = false;
        } else {
          if (this.timeRadio == 3) {
            let obj = res.data.data.filter(item => item.date_name == "本月");

            this.start_timenew = obj[0].start_time;
            this.end_timenew = obj[0].end_time;
          }
          if (this.timeRadio == 1) {
            let obj = res.data.data.filter(item => item.date_name == "今年");

            this.start_timenew = obj[0].start_time;
            this.end_timenew = obj[0].end_time;
          }
          if (this.timeRadio == 2) {
            let obj = res.data.data.filter(item => item.date_name == "本季度");

            this.start_timenew = obj[0].start_time;
            this.end_timenew = obj[0].end_time;
          }
          this.disabled = true;

          this.changeData();
        }
      }
    },
    // 初始
    init() {
      // if (window.localStorage.getItem("timeRadio")) {
      //   this.timeRadio = +window.localStorage.getItem("timeRadio");
      // }
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
      end = this.moment(end).format("YYYY-MM-DD");
      start = this.moment(start).format("YYYY-MM-DD");

      this.date = [start, end];
      let p0 = new Promise((resolve, reject) => {
        resolve(this.myVendorList());
      });
      let p1 = new Promise((resolve, reject) => {
        resolve(this.getCarData());
      });
      let p2 = new Promise((resolve, reject) => {
        resolve(this.getMedia());
      });
      let p3 = new Promise((resolve, reject) => {
        resolve(this.catList());
      });
      let p4 = new Promise((resolve, reject) => {
        resolve(this.getProduct());
      });
      // let p4 = new Promise((resolve, reject) => {
      //   resolve(this.carTypeList());
      // });
      // p1, p2, p3
      Promise.all([p0, p1, p2, p3, p4])
          .then(result => {
            // let vendor=this.checkVendor.join(',');
            // let mediaArry = this.checkMedia.slice(1);
            // let media = mediaArry.join(",");
            // let brand = this.checkedCar.join(",");
            // this.allchange.brand = brand;
            // this.allchange.media = media;
            // this.allchange.class_type = 0;
            // this.allchange.date_type = 1;
            // this.changeData()
            this.changeData();
          })
          .catch(error => {
          });
    },
    // 改变数据
    changeData(index) {
      if (index) {
        this.btntext0 = "展开";
        this.btntext = "展开";
        this.btntext2 = "展开";
      }
      if (index == 1) {
        this.nowindex = 1;
      } else if (index == 2) {
        this.nowindex = 2;
      } else if (index == 0) {
        this.nowindex = 0;
      }

      let mediaArry = [];
      let brandList = [];
      let radio = null;
      let class_content = "";
      let start_time = "";
      let end_time = "";

      if (this.checkedCar.includes(0)) {
        brandList = this.checkedCar.slice(1);
      } else {
        brandList = this.checkedCar;
      }
      if (this.cproductallm) {
        mediaArry = ["全部"];
      } else {
        mediaArry = this.checkMedia;
      }
      // mediaArry = this.checkMedia;
      if (this.radio) {
        radio = 0;
      } else {
        radio = 1;
        if (this.grade1) {
          class_content = this.grade1;
        }
        if (this.grade2) {
          class_content = this.grade1 + "," + this.grade2;
        }
        if (this.grade3) {
          class_content = this.grade1 + "," + this.grade2 + "," + this.grade3;
        }
      }
      let datenew = new Date();

      let timeRadio;
      if (this.timeRadio == 0) {
        start_time = this.date[0];
        end_time = this.date[1];
        timeRadio = 0;
      } else if (this.timeRadio == 4) {
        let nowday = this.moment(datenew.setDate(datenew.getDate())).format(
            "YYYY-MM-DD"
        );
        start_time = nowday;
        end_time = nowday;
        timeRadio = 0;
      } else if (this.timeRadio == 5) {
        let nowday1 = this.moment(
            datenew.setDate(datenew.getDate() - 1)
        ).format("YYYY-MM-DD");
        start_time = nowday1;
        end_time = nowday1;
        timeRadio = 0;
      } else if (this.timeRadio == 6) {
        let nowday3 = this.moment(datenew.setDate(datenew.getDate())).format(
            "YYYY-MM-DD"
        );
        let nowday2 = this.moment(
            datenew.setDate(datenew.getDate() - 29)
        ).format("YYYY-MM-DD");

        start_time = nowday2;
        end_time = nowday3;
        timeRadio = 0;
      } else if (this.timeRadio == 7) {
        let nowday3 = this.moment(datenew.setDate(datenew.getDate())).format(
            "YYYY-MM-DD"
        );
        let nowday2 = this.moment(
            datenew.setDate(datenew.getDate() - 89)
        ).format("YYYY-MM-DD");

        start_time = nowday2;
        end_time = nowday3;
        timeRadio = 0;
      } else if (this.timeRadio == 8) {
        let nowday3 = this.moment(datenew.setDate(datenew.getDate())).format(
            "YYYY-MM-DD"
        );
        let nowday2 = this.moment(
            datenew.setDate(datenew.getDate() - 179)
        ).format("YYYY-MM-DD");

        start_time = nowday2;
        end_time = nowday3;
        timeRadio = 0;
      } else {
        start_time = this.start_timenew;
        end_time = this.end_timenew;
        timeRadio = this.timeRadio;
      }

      //产品
      let pro_ids = "";
      let Label = "";
      if (this.nowindex == 0) {
        let productList = [];
        if (this.checkedProduct.includes(0)) {
          productList = this.checkedProduct.slice(1);
          if (
              window.localStorage.getItem("company_type") == 2 &&
              productList.includes(10000)
          ) {
            productList = productList.concat(this.checkedProduct2);
          }
        } else {
          productList = this.checkedProduct;
          if (
              window.localStorage.getItem("company_type") == 2 &&
              productList.includes(10000)
          ) {
            productList = productList.concat(this.checkedProduct2);
          }
        }
        pro_ids = productList.join(",");

        this.carProduct.forEach(item => {
          if (pro_ids == item.id) {
            Label = item.name;
          }
        });
      } else {
        pro_ids = "";
      }

      // 车型
      // let type_ids = "";
      // if (this.nowindex == 2) {
      //   let carList = [];
      //   if (this.checkedCarType.includes("全部")) {
      //     carList = this.checkedCarType.slice(1);
      //   } else {
      //     carList = this.checkedCarType;
      //   }
      //   type_ids = carList.join(",");
      // } else {
      //   type_ids = "";
      // }

      //厂商
      let vendorArry = [];
      if (this.checkVendor.includes("全部")) {
        vendorArry = this.checkVendor.slice(1);
      } else {
        vendorArry = this.checkVendor;
      }
      let vendor = vendorArry.join(",");
      if (this.nowindex == 2) {
        if (vendorArry.length > 1) {
          Label = vendorArry[0] + "等产商";
        } else {
          Label = vendorArry[0];
        }
      }
      let brandName = this.carBanner[0].name;
      let brand = brandList.join(",");
      let media = mediaArry.join(",");
      if (this.nowindex == 1) {
        if (this.carBanner.length > 1) {
          Label = this.carBanner[1].name + "等品牌";
        } else {
          Label = this.carBanner[0].name;
        }
      }
      if (this.emotion) {
        this.allchange.emotionRadio = this.emotionRadio;
        this.allchange.sourceRadio = this.sourceRadio;
        this.allchange.detetypeRadio = this.detetypeRadio;
      }
      this.allchange.brand = brand;
      this.allchange.vendor = vendor;
      this.allchange.media = media;
      this.allchange.class_type = radio;
      this.allchange.class_content = class_content;
      this.allchange.date_type = timeRadio;
      this.allchange.start_time = start_time;
      this.allchange.end_time = end_time;
      this.allchange.pro_ids = pro_ids;
      // this.allchange.type_ids = type_ids;
      this.allchange.brandName = brandName;
      this.allchange.Label = Label;
      this.allchange.productName = this.productName;

      this.$emit("getData", this.allchange);
    },
    // 获取所有的内容分类列表
    async catList() {
      let one_classify = "";
      if (this.floor == 3) {
        one_classify = this.grade1;
      }
      let params = {
        floor: this.floor,
        name: this.floorName,
        one_classify: one_classify
      };
      let res = await this.$api.communal.catList(params);
      if (res.data.error === 0) {
        if (this.floor == 1) {
          this.oneList = [...res.data.data];
        } else if (this.floor == 2) {
          this.twoList = [...res.data.data];
        } else {
          this.threeList = [...res.data.data];
        }
      }
    },
    onechange() {
      if (this.grade1) {
        this.floor = 2;
        this.grade2 = "";
        this.grade3 = "";
        this.floorName = this.grade1;
        this.catList();
        this.changeData();
      }
    },
    twochange() {
      if (this.grade2) {
        this.floor = 3;
        this.grade3 = "";
        this.floorName = this.grade2;
        this.catList();
        this.changeData();
      }
    },
    threechange() {
      if (this.grade3) {
        this.changeData();
      }
    },
    //获取能源类型
    async energyList() {
      let brand_id = this.checkedCar.join(",");
      let pro_id = this.checkedProduct.join(",");
      let params = {
        brand_id: brand_id,
        pro_id: pro_id
      };
      let res = await this.$api.communal.energyList(params);
      if (res.data.error == 0) {
        this.energyData = [...res.data.data[0].list];
        let obj = {
          id: 0,
          energy_name: "全部"
        };
        this.energyData.unshift(obj);
        let arry = [];
        this.energyData.forEach(item => {
          arry.push(item.id);
        });
        this.checkEnergy = [...arry];
      }
    },
    //获取所有的车型列表
    async carTypeList() {
      let res = await this.$api.communal.carTypeList();

      if (res.data.error == 0) {
        this.carType = [...res.data.data];
        let obj = {
          cname: "全部"
        };
        this.carType.unshift(obj);
        let arry = [];
        this.carType.forEach(item => {
          arry.push(item.cname);
        });
        this.checkedCarType = [...arry];
      }
    },
    changetime(val) {
      this.changeData();
    },

    // 车场
    async myVendorList() {
      let company_type = window.localStorage.getItem("company_type");
      let res = await this.$api.communal.myVendorList();
      if (res.data.error === 0) {
        this.vendorList = [...res.data.data_no_rank];
        this.vendorList.forEach(item => {
          this.checkVendor.push(item.name);
          console.log(item.name);
          let a = item.name.split("-");
          if (a.length > 1) {
            if (a[1].length > 4) {
              if (a.length > 2) {
                item.name2 = a[1] + a[2];
              } else {
                item.name2 = a[1];
              }
            } else {
              if (a.length > 2) {
                item.name2 = a[1] + a[2];
              } else {
                item.name2 = a[1];
              }
            }
          } else {
            item.name2 = a[0];
          }
        });
        // this.changeData();
      } else {
        this.$message.error(res.data.msg);
      }
      // if (company_type == 1) {

      // } else if (company_type == 2) {
      //   let res = await this.$api.communal.vendorList();
      //   if (res.data.error === 0) {
      //     this.vendorList = [...res.data.data];
      //     // let obj = {
      //     //   name: "全部"
      //     // };

      //     // this.vendorList.unshift(obj);

      //     this.vendorList.forEach((item, index) => {
      //       if (index < 50) {
      //         this.checkVendor.push(item.name);
      //       }
      //     });
      //   } else {
      //     this.$message.error(res.data.msg);
      //   }
      // }
    },
    // 时间显示
    timeshow(val) {
      this.$nextTick(() => {
        this.date = [val.start_time, val.end_time];
      });
    },
    // 情感选择
    emotionChange(e) {
      this.emotionRadio = e;
      this.changeData();
    },
    sourceChange(e) {
      this.sourceRadio = e;
      this.changeData();
    },
    detetypeChange(e) {
      this.detetypeRadio = e;
      this.changeData();
    },
    // 搜索条件展示
    changeshow(val) {
      this.changetype = val;
    }
  },
  watch: {
    grade1(val) {
      if (!val) {
        this.radio = true;
        this.grade2 = "";
        this.twoList = [];
        this.changeData();
      }
    },
    grade2(val) {
      if (!val) {
        this.grade3 = "";
        this.threeList = [];
        this.changeData();
      }
    },
    grade3(val) {
      if (!val) {
        this.changeData();
      }
    },
    radio(val) {
      if (val) {
        this.grade1 = "";
        this.grade2 = "";
        this.grade3 = "";

        this.twoList = [];
        this.threeList = [];
        this.changeData();
      }
    },
    checkMedia(val) {
      if (val.includes(0)) {
        this.mediaData[this.mediaData.length - 1].media_name =
            this.lastmeidio + "\xa0\xa0" + "\xa0\xa0" + "\xa0\xa0等1000+媒体平台";
      } else {
        this.mediaData[this.mediaData.length - 1].media_name = this.lastmeidio;
      }
    }
  }
};
</script>
<style scoped>
.select-li {
  /* height: 55px; */
  /* padding: 10px 0; */
  border-bottom: 1px dashed #cacaca;
}

.select-li.select-libot {
  border-bottom: 0;
}

.tag-title {
  width: 72px;
  float: left;
  font-size: 13px;
  color: #141a88;
  line-height: 50px;
  text-align: right;
  margin-right: 15px;
}

.ml {
  margin-right: 20px;
  color: #000000;
}

.select-li .fz {
  color: #000000;

  /* height: 50px; */
  margin-left: 87px;
  margin-right: 105px;
}

.select-li .right {
  float: right;
  width: 105px;
  line-height: 50px;
  text-align: right;
}

.select-li .btn {
  width: 47px;
  height: 23px;
  background-color: #f4f4fa;
  color: #141a88;
  border: solid 1px #c1c1c1;
}

.check-option {
  height: 50px;
  overflow: hidden;
  line-height: 50px;
  color: #000000;
}

.check-option-min {
  display: flex;
  /*display: grid;*/
  /*grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));*/
  /*grid-column-gap: 0px;*/

  height: 50px;
  flex-wrap: wrap;
  overflow: hidden;
  line-height: 50px;
  color: #000000;
  /*padding-left: 31px;*/
}

.check-option-max {
  /*display: grid;*/
  /*grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));*/
  /*grid-column-gap: 10px;*/

  padding-top: 15px;
  color: #000000;
  /*padding-left: 31px;*/
  padding-bottom: 10px;
  /*grid-row-gap: 3px;*/
}

.select-li .open {
  height: auto;
  line-height: 14px;
  /* overflow: hidden;
  overflow-y: auto; */
}

.select-li .mt {
  margin-top: -10px;
}

.radio {
  line-height: 50px;
}

.selectW {
  width: 150px;
  margin-right: 20px;
}

.open-new {
  padding: 5px 0;
  /* max-height: 60px; */
  /* overflow: hidden; */
  /* overflow-y: scroll; */
}

.ml10 {
  margin-left: 10px;
}

.check-all {
  /* display: inline-block; */
  float: left;
  line-height: 50px;
  margin-right: 15px !important;
}

.name-style {
  display: inline-block;

  vertical-align: -3%;
  margin-right: 2px;
}

.img-v {
  vertical-align: -14%;
}

.line-erect {
  position: absolute;
  border-left: 2px solid #dfdfdf;
  left: 0;
  top: 15px;
  height: 20px;
}

.line-erect2 {
  position: absolute;
  border-left: 2px solid #dfdfdf;
  left: 0;
  top: 2px;
  height: 15px;
}

.prbox {
  /*position: relative;*/
}
</style>
<style>
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #141a88 !important;
}

.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #e5e5e5 !important;
  border-color: #e5e5e5 !important;
}

.el-checkbox__inner:hover {
  border-color: #dcdfe6 !important;
}

.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #dcdfe6 !important;
}

.change-c .el-radio__inner::after {
  box-sizing: content-box;
  content: "";
  height: 6px !important;
  width: 3px !important;
  left: 3px !important;
  position: absolute !important;
  top: 1px !important;
  border: 2.4px solid #424242 !important;
  border-top: 0px !important;
  border-left: 0px !important;
  transform-origin: center;
  background-color: transparent;
}

.change-c .el-radio__input.is-checked .el-radio__inner::after {
  transform: rotate(45deg) !important;
}

.change-c .el-checkbox__label {
  padding-left: 2px !important;
}

.change-c .fz .el-checkbox {
  width: 144px !important;
  margin-right: 0px;
  padding: 0 15px;
  box-sizing: border-box;
}
</style>